module.exports = __webpack_public_path__ + "static/media/yotpo-reviews.ea65854b.png";